import { Helmet } from 'react-helmet';
import { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CancelIcon from '@mui/icons-material/Cancel';

import {
  UploadCloud as UploadCloudIcon,
  List as ListIcon,
  Clock as ClockIcon,
} from 'react-feather';

import PageContentWrapper from "../components/PageContentWrapper"
import ScansContext from "../contexts/ScansContext"

import { getCurrentUser } from "../utils/auth"
import APIS from "../utils/APIS"

const CreateScan = () => {
  const navigate = useNavigate();
  let accountType = getCurrentUser()?.type
  const { getScans } = useContext(ScansContext)

  useEffect(() => {
    if (accountType !== "theScanRecruiter") {
      navigate('/')
    }
  }, [accountType])


  const uploadInputRef = useRef(null)
  const [step, setStep] = useState(0)
  const [type, setType] = useState(null)
  const [jobDescription, setJobDescription] = useState("")
  const [scanName, setScanName] = useState("")
  const [jobFile, setJobFile] = useState(null)
  const [uploadProgress, setUploadProgress] = useState(null)
  /* B36 (25/09/2026) : la confirmation « Votre offre est transmise » s'affichait
     des que le fichier avait fini de MONTER, avant la reponse du serveur ; un
     refus passait donc pour un succes, suivi d'une alerte « Erreur ! » brute.
     Desormais : envoi en cours = bouton bloque (plus de double envoi) ; la
     confirmation n'arrive qu'avec l'accord du serveur ; sinon, un message clair
     sous le bouton, et l'utilisateur reste sur l'etape pour reessayer. */
  const [envoiEnCours, setEnvoiEnCours] = useState(false)
  const [erreurCreation, setErreurCreation] = useState(null)
  const MESSAGE_ECHEC = "La création du scan n'a pas abouti. Vérifiez votre offre et vos Scans, puis réessayez. Si le problème continue, écrivez-nous depuis le support."
  /* Verrou immediat : l'etat React ne suffit pas si deux clics tombent dans le
     meme lot de rendu (relecture du 25/09). */
  const envoiRef = useRef(false)

  const onChangeUploadInput = (e) => {
    if (e?.target?.files[0]) {
      setJobFile(e?.target?.files[0])
    }
  }

  const createScan = async () => {
    if (envoiRef.current) return
    envoiRef.current = true
    setEnvoiEnCours(true)
    setErreurCreation(null)
    // La confirmation passe AVANT le rechargement de la liste : une exception de
    // getScans ne peut plus faire croire a un echec (et pousser a un doublon).
    const reussite = () => { envoiRef.current = false; setEnvoiEnCours(false); setUploadProgress(null); setStep(100); getScans() }
    const echec = () => { envoiRef.current = false; setEnvoiEnCours(false); setUploadProgress(null); setErreurCreation(MESSAGE_ECHEC) }
    if (type === "description") {
      const vals = { type: type, name: scanName, userID: getCurrentUser()?.id, description : jobDescription }
      APIS.addScanWithDescription(vals).then(result => {
        if (result?.message === "addScanWithDescription") reussite()
        else echec()
      }, echec)
    } else if (type === "file") {
      setUploadProgress(0)
      const formData = new FormData();
      formData.append('type', type)
      formData.append('name', scanName)
      formData.append('file', jobFile);
      formData.append('userID', getCurrentUser()?.id)
      const onUploadProgress = (progressEvent) => {
        if (!progressEvent?.total) return
        setUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
      }
      APIS.addScanWithPDF(formData, onUploadProgress).then(result => {
        if (result?.message === "addScanWithPDF") reussite()
        else echec()
      }, echec)
    }
  }

  return (
    <>
      <Helmet>
        <title>Créer Scan | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'white',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        <PageContentWrapper withoutHeader >
          {step === 0 &&
            <Box sx={{display:"flex", flexDirection:"column", gap:["20px", "40px", "80px"], alignItems:"center", justifyContent:"center", flexGrow:1}}>
              <Box sx={{
                fontSize:["32px", "46px", "52px"],
                fontWeight : 500,
                textAlign:"center",
              }}>Créer un Scan</Box>
              <Box sx={{width:"100%", display:"flex", justifyContent:"center", flexWrap:"wrap", gap:["20px", "40px", "150px"]}}>
                <Box onClick={() => { setType("file"); setStep(10); }} sx={{
                  width:["100%", "380px"],
                  height:["175px", "250px"],
                  background:"white",
                  border:"1px solid #E7E7E7",
                  cursor:"pointer",
                  display:"flex",
                  flexDirection:"column",
                  justifyContent:"center",
                  alignItems:"center",
                  userSelect:"none",
                  gap:"20px",
                  "&:hover":{
                    border:"1px solid black",
                  }
                }}>
                  <Box sx={{color:"text.primary", width:["52px", "64px", "64px"]}}>
                    <UploadCloudIcon style={{width:"100%", height:"100%"}}/>
                  </Box>
                  <Box sx={{
                    fontSize:["22px", "26px", "26px"],
                    fontWeight : 500,
                  }}>
                    Télécharger une offre
                  </Box>
                </Box>
                <Box onClick={() => { setType("description"); setStep(20); }} sx={{
                  width:["100%", "380px"],
                  height:["175px", "250px"],
                  background:"white",
                  border:"1px solid #E7E7E7",
                  cursor:"pointer",
                  display:"flex",
                  flexDirection:"column",
                  justifyContent:"center",
                  alignItems:"center",
                  userSelect:"none",
                  gap:"20px",
                  "&:hover":{
                    border:"1px solid black",
                  }
                }}>
                  <Box sx={{color:"text.primary", width:["52px", "64px", "64px"]}}>
                    <ListIcon style={{width:"100%", height:"100%"}}/>
                  </Box>
                  <Box sx={{
                    fontSize:["22px", "26px", "26px"],
                    fontWeight : 500,
                  }}>
                    Écrire une description
                  </Box>
                </Box>
              </Box>
            </Box>
          }

          {step === 10 && //upload offre choisir fichier
            <Box sx={{display:"flex", flexDirection:"column", gap:["20px", "40px", "40px"], alignItems:"center", justifyContent:"center", flexGrow:1}}>
              <Box sx={{
                fontSize:["32px", "46px", "52px"],
                fontWeight : 500,
                textAlign:"center",
              }}>Télécharger une offre d'emploi</Box>
              <Box sx={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:["20px", "30px", "30px"]}}>
                <Box
                  sx={{
                    height:"245px",
                    width:"100%",
                    maxWidth:"800px",
                    background:"white",
                    border:"1px solid #E7E7E7",
                    cursor:"pointer",
                    display:"flex",
                    flexDirection:"column",
                    justifyContent:"center",
                    alignItems:"center",
                    userSelect:"none",
                    gap:"20px",
                    "&:hover":{
                      border:"1px solid black",
                    }
                  }}
                  onClick={() => uploadInputRef.current && uploadInputRef.current.click()}
                >
                  <Box sx={{color:"text.primary", width:["52px", "64px", "64px"]}}>
                    <UploadCloudIcon style={{width:"100%", height:"100%"}}/>
                  </Box>
                  {jobFile === null ? (
                    <>
                      <Box sx={{
                        fontSize:"22px",
                        fontWeight : 500,
                        color:"text.primary",
                      }}>
                        Télécharger une offre
                      </Box>
                      <Box sx={{
                        fontSize:"14px",
                        fontWeight : 500,
                        color:"text.primary",
                      }}>
                        PDF (5MB max)
                      </Box>
                    </>
                  ) : (
                    <Box sx={{display:"flex", alignItems:"center", gap:"10px"}}>
                      <Box sx={{
                        fontSize:"22px",
                        fontWeight : 500,
                        color:"text.black",
                      }}>
                        {jobFile?.name}
                      </Box>
                      <CancelIcon
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setJobFile(null)
                          if (uploadInputRef.current) {
                            uploadInputRef.current.value = null
                          }

                        }}
                      />
                    </Box>
                  )}
                </Box>
                <Button
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                  endIcon={<ChevronRightIcon/>}
                  disabled={jobFile === null}
                  onClick={() => { setStep(30) }}
                >
                  Suivant
                </Button>
              </Box>
            </Box>
          }

          {step === 20 && //écrire description
            <Box sx={{display:"flex", flexDirection:"column", gap:["20px", "40px", "40px"], alignItems:"center", justifyContent:"center", flexGrow:1}}>
              <Box sx={{
                fontSize:["32px", "46px", "52px"],
                fontWeight : 500,
                textAlign:"center",
              }}>Écrire une description du poste</Box>
              <Box sx={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:["20px", "30px", "30px"]}}>
                <TextField
                  name="jobDescription"
                  label="Description"
                  placeholder="Description ..."
                  fullWidth
                  multiline
                  rows={6}
                  sx={{
                    maxWidth : "800px"
                  }}
                  value={jobDescription}
                  onChange={(e) => setJobDescription(e.target.value)}
                />
                <Button
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                  endIcon={<ChevronRightIcon/>}
                  disabled={jobDescription.length < 10}
                  onClick={() => { setStep(30) }}
                >
                  Suivant
                </Button>
              </Box>
            </Box>
          }

          {step === 30 && //nom
            <Box sx={{display:"flex", flexDirection:"column", gap:["20px", "40px", "40px"], alignItems:"center", justifyContent:"center", flexGrow:1}}>
              <Box sx={{
                fontSize:["32px", "46px", "52px"],
                fontWeight : 500,
                textAlign:"center",
              }}>Donner un nom à votre offre d’emploi</Box>
              <Box sx={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:["20px", "30px", "30px"]}}>
                <TextField
                  name="scanName"
                  label=""
                  placeholder="Développeur junior ..."
                  fullWidth
                  inputProps={{ maxLength: 200 }}
                  InputLabelProps={{
                      shrink: true,
                  }}
                  sx={{
                    maxWidth : "500px"
                  }}
                  value={scanName}
                  onChange={(e) => setScanName(e.target.value)}
                />
                <Button
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                  endIcon={<ChevronRightIcon/>}
                  disabled={scanName.length < 3 || envoiEnCours}
                  onClick={createScan}
                >
                  Créer le Scan
                </Button>
                {(type === "file" && uploadProgress !== null) &&
                  <Box
                    sx={{
                      pb: 1,
                      pt: 0
                    }}
                  >
                    <Typography
                      align="left"
                      color="green"
                      variant="body1"
                    >
                      {uploadProgress < 100 ? `Téléchargement ... ${uploadProgress}\u00a0%` : "Fichier reçu, enregistrement du scan\u2026"}
                    </Typography>
                  </Box>
                }
                {erreurCreation &&
                  <Typography role="alert" align="center" color="error" variant="body1" sx={{ maxWidth: "500px" }}>
                    {erreurCreation}
                  </Typography>
                }
              </Box>
            </Box>
          }

          {step === 100 && //final
            <Box sx={{display:"flex", flexDirection:"column", gap:["20px", "40px", "40px"], alignItems:"center", justifyContent:"center", flexGrow:1}}>
              <Box sx={{color:"text.black", width:["60px", "70px", "70px"]}}>
                <ClockIcon style={{width:"100%", height:"100%"}}/>
              </Box>
              <Box sx={{
                fontSize:["32px", "46px", "52px"],
                fontWeight : 500,
                textAlign:"center",
              }}>Vous y êtes presque</Box>
              <Box sx={{width:"100%", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:["20px", "30px", "30px"]}}>
                <Box sx={{
                  fontSize:"20px",
                  fontWeight : 500,
                  color:"text.primary",
                  maxWidth:"500px",
                  textAlign:"center",
                }}>
                  Votre offre est transmise à nos équipes, qui préparent l'évaluation adaptée au poste. Elle apparaîtra comme « En cours de préparation » dans vos Scans, puis deviendra jouable dès qu'elle sera prête.
                </Box>
                <Button
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                  endIcon={<ChevronRightIcon/>}
                  onClick={() => {
                    navigate('/app/scans')
                  }}
                >
                  Compris&nbsp;!
                </Button>
              </Box>
            </Box>
          }

          <input ref={uploadInputRef} name="fileJob" type="file" accept="application/pdf" style={{display:"none"}} onChange={onChangeUploadInput}/>

        </PageContentWrapper>
      </Box>
    </>
  )
};

export default CreateScan;
